module.exports = __webpack_public_path__ + "img/youtube1.3a36206f.png";